import React from 'react'

import { ReactComponent as SuccessIcon } from '@percent/admin-dashboard/common/assets/images/success.svg'
import { ReactComponent as RejectedIcon } from '@percent/admin-dashboard/common/assets/images/rejected.svg'
import styles from './ActionDialog.module.scss'
import { Box, Button, Spacer, Typography } from '@percent/lemonade'
import { ActionDialogActionProps } from './ActionDialog.types'

export function ActionsDialogAction({
  handleOnClose,
  description,
  title,
  buttonTitle,
  successIcon
}: ActionDialogActionProps) {
  return (
    <Box className={styles.actionDialogContent}>
      <div className={styles.svg}>
        {(successIcon && <SuccessIcon className={styles.icon} />) || <RejectedIcon className={styles.icon} />}
      </div>
      <Spacer size={4} axis="vertical" />
      <Typography variant="h2" className={styles.title}>
        {title}
      </Typography>
      <Typography variant="large" className={styles.description}>
        {description}
      </Typography>
      <div className={styles.singleButtonWrapper}>
        <Button onClick={handleOnClose} variant="primary">
          {buttonTitle}
        </Button>
      </div>
    </Box>
  )
}
